module.exports = __webpack_public_path__ + "img/micro-datacenter.0f0a93df.svg";